import React from 'react';
import millify from 'millify';
import { Typography, Row, Col, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useGetCryptosQuery } from "../features/api";


import Cryptocurrencies from './Cryptocurrencies';
import News from './News';
import { Button, CircularProgress } from '@mui/material';

import { useHistory } from "react-router-dom";


const { Title } = Typography;

const Homepage = () => {

    const history = useHistory()

    const { data, isFetching } = useGetCryptosQuery(10);
    const globalStats = data?.data?.stats;

    if(isFetching) return <CircularProgress color="secondary" />;
    
    return (
        <>
            <Typography variant="h1" component="h1">Cryptocurrency App</Typography>  
            <Row>
                <Col span={12}><Statistic title="Total Cryptocurrencies" value={globalStats.total}/></Col>
                <Col span={12}><Statistic title="Total Exchanges" value={millify(globalStats.totalExchanges)}/></Col>
                <Col span={12}><Statistic title="Total Market Cap" value={millify(globalStats.totalMarketCap)}/></Col>
                <Col span={12}><Statistic title="Total 24h Volume" value={millify(globalStats.total24hVolume)}/></Col>
                <Col span={12}><Statistic title="Total Markets" value={millify(globalStats.totalMarkets)}/></Col>
            </Row>
            <Cryptocurrencies simplified />
            <div className="home-heading-container">
                {/* <Title level={2} className="home-title">Top 10 Cryptocurrencies in the world</Title> */}
                <Button sx={{mb: 6}} variant="contained" onClick={() => history.push('/cryptocurrencies')}>Show More</Button>
            </div>
            
            <News simplified />
            <div className="home-heading-container">
                {/* <Title level={2} className="home-title">Latest Crypto News</Title> */}
                
                <Button sx={{mb: 6}}  variant="contained" onClick={() => history.push('/news')}>Show More</Button>
            </div>
            
        </>
    )
}

export default Homepage
